export class TemaPrioritario{
    id:number;
    descrizione:string;    
}